import type HttpStatusCode from './HttpStatusCode';

export function isAuthStatusCode(statusCode: number): boolean {
    return statusCode == 401 || statusCode == 440;
}
